import type { RadioGroupResult } from '@myosh/odin-components';

export const labelDecimalFormatter = (labelDecimals?: RadioGroupResult | number) => {
  if (!labelDecimals) {
    return undefined;
  }

  if (typeof labelDecimals === 'number') {
    return labelDecimals;
  }

  if (labelDecimals.value === 'one') {
    return 1;
  } else if (labelDecimals.value === 'two') {
    return 2;
  } else {
    return 0;
  }
};
